import React from 'react'

import useStyles from '../styles'
import useDrawerFormStyles from '../../../../../../../../styles/common/drawerForms'

const ImageSupportedFormatsAndSizes = () => {
  const classes = useStyles()
  const drawerFormClasses = useDrawerFormStyles()

  return (
    <section className={drawerFormClasses.section}>
      <h4 className={drawerFormClasses.sectionTitle}>Supported formats:</h4>
      <ul className={classes.list}>
        <li>.jpg</li>
        <li>.jpeg</li>
        <li>.gif</li>
        <li>.png</li>
      </ul>
      <br />
      <h4 className={drawerFormClasses.sectionTitle}>Supported sizes:</h4>
      <ul className={classes.list}>
        <li>Square and rectangle: 250 × 250, 300 × 250, 320 × 320, 336 × 280</li>
        <li>Skyscraper: 120 × 600, 160 × 600, 300 × 600, 300 × 1050</li>
        <li>Leaderboard: 468 × 60, 728 × 90, 800 × 250, 970 × 90, 970 × 250</li>
        <li>Mobile: 300 × 50, 300 × 100, 320 × 50, 320 × 100, 320 × 480, 360 × 592, 360 × 640, 375 × 667</li>
      </ul>
    </section>
  )
}

export default ImageSupportedFormatsAndSizes
